import { FormRows } from '@acorns/web-components'
import { object } from 'yup'

import employerInfoSchema from 'utils/validation-schemas/employer-info'

export const validationSchema = object().concat(employerInfoSchema)

export const handleSubmit = (_, { props }) => {
  props.setShowConfirmModal(true)
}

export const employerInfoRows = (showEmployerNameLabel = false): FormRows => [
  [
    {
      label: 'Employer Name:',
      hasHiddenLabel: !showEmployerNameLabel,
      name: 'name',
      type: 'text',
      sizes: { sm: 12, md: 12, xs: 12 },
      placeholder: 'Name',
    },
  ],
]
